import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/es/styles/withStyles";
import {MAIN_SCREEN} from "../../ducks/duck-screen";
import {Transition} from "react-transition-group";

// import './animation.css';

const styles = theme => ({
	"root": {
		transform: "scale(0.95)",
		opacity: 1,
		"flex": 1,
		"minHeight": 0,
		"display": "flex",
		"flex-flow": "column",
		'overflow-y': "auto",
		'overflow-x': "hidden",
		overflowScrolling: "touch",
		WebkitOverflowScrolling: "touch",
		overscrollBehavior: "none",
		height: '100%',
	}
});

const transitionStyles = {
	entering: { opacity: 1, transform: "translateX(0)" },
	entered:  { opacity: 1 },
	exiting:  { opacity: 0, transform: "scale(0.95)" },
	// exited:  { opacity: 1, transform: "translateX(0)" ,  transition: "opacity 300ms cubic-bezier(0.39, 0.575, 0.565, 1), transform 300ms cubic-bezier(0.39, 0.575, 0.565, 1)"},
	exited:  {
		opacity: 1,
		transform: "translateX(0)" ,
		// "-webkit-transition": "opacity 300ms cubic-bezier(0.39, 0.575, 0.565, 1), transform 300ms cubic-bezier(0.39, 0.575, 0.565, 1)",
		// "-o-transition": "opacity 300ms cubic-bezier(0.39, 0.575, 0.565, 1), transform 300ms cubic-bezier(0.39, 0.575, 0.565, 1)",
		// transition: "opacity 300ms cubic-bezier(0.39, 0.575, 0.565, 1), transform 300ms cubic-bezier(0.39, 0.575, 0.565, 1)"

		"WebkitTransition": "opacity 300ms cubic-bezier(0.39, 0.575, 0.565, 1), -webkit-transform 300ms cubic-bezier(0.39, 0.575, 0.565, 1)",
		"OTransition": "opacity 300ms cubic-bezier(0.39, 0.575, 0.565, 1), transform 300ms cubic-bezier(0.39, 0.575, 0.565, 1)",
		"transition": "opacity 300ms cubic-bezier(0.39, 0.575, 0.565, 1), transform 300ms cubic-bezier(0.39, 0.575, 0.565, 1), -webkit-transform 300ms     cubic-bezier(0.39, 0.575, 0.565, 1)"
	},
};

//
// const styles = theme => ({
// 	"root": {
// 		opacity: 1,
// 		height: "100%",
// 	}
// });
//
// const transitionStyles = {
// 	entering: { opacity: 1 },
// 	entered:  { opacity: 1 },
// 	exiting:  { opacity: 0 },
// 	exited:  { opacity: 1,  transition: "opacity 150ms"},
// };

class AnimationWrapper extends React.Component {
	state = {
		currentScreen: MAIN_SCREEN,
		didScreenChange: false
	};

	static getDerivedStateFromProps(props, state){
		// debugger;

		if(props.currentScreen !== state.currentScreen){
			return {
				// currentScreen: props.currentScreen,
				didScreenChange: true
			}
		} else {
			return null
		}
	}

	componentDidMount(){
		console.log("componentDidMount")
		this.setState({
			didScreenChange: true
		})
	}

	componentDidUpdate(prevProps, prevState){
		// debugger;
		if(this.state.currentScreen !== this.props.currentScreen ){
			this.updateStateAfterAnimation(this.props.currentScreen)
		}
	}

	updateStateAfterAnimation = (currentScreen) => {
		this.setState({
			currentScreen,
			didScreenChange: false
		})
	};

	render(){
		// console.log(this.state.didScreenChange);
		const {classes, id} = this.props;
		return (
			<Transition in={this.state.didScreenChange} timeout={0}>
				{state => (
					<div style={{...transitionStyles[state]}} className={classes.root} id={id}>
						{this.props.children}
					</div>
				)}
			</Transition>
		)
	}
}

AnimationWrapper.propTypes = {
	currentScreen: PropTypes.string.isRequired,

	classes: PropTypes.shape({
		root: PropTypes.string.isRequired
	}).isRequired,

};

export default withStyles(styles)(AnimationWrapper);